module.exports = __webpack_public_path__ + "static/media/facebook.68ac7dc8.svg";